module.exports = __webpack_public_path__ + "static/media/down-arrow.5a171ba3.svg";